import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
    GrupoViewModel,
    FormaViewModel,
    GrupoItemResultsViewModel,
    FormaItemResultsViewModel,
    SubFormaItemResultsViewModel,
    SubFormaViewModel,
    FilterSearchingGrupoViewModel,
} from './grupoforma.types';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { ResetFiltersService } from '../../../core/_infrastructure/classes/services/reset-filters.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';

@Injectable()
export class GrupoFormaService extends ResetFiltersService {

    public currentFilterGrupo?: FilterSearchingGrupoViewModel;

    constructor(
        protected authService: AuthService,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {
        super(authService);
    }

    private convertModelToHttpParams(payload: FilterSearchingGrupoViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingGrupoViewModel;

        for (k in payload) {
            const v = payload[k];
            if (v !== null && v !== undefined && v !== '') {
                params = params.append(k, v.toString());
            }
        }

        return params;
    }

    getGrupo(id: number): Observable<GrupoViewModel> {
        return this.http.get<GrupoViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/' + id).pipe();
    }

    getAllGrupos(): Observable<GrupoItemResultsViewModel> {
        return this.http.get<GrupoItemResultsViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/all').pipe();
    }

    getGrupos(payload: FilterSearchingGrupoViewModel): Observable<GrupoItemResultsViewModel> {
        this.currentFilterGrupo = payload; 
        const params = this.convertModelToHttpParams(payload); 
        return this.getGruposPagedByFilter(params); 
    }

    getGruposPagedByFilter(params: HttpParams): Observable<GrupoItemResultsViewModel> {
        return this.http
            .get<GrupoItemResultsViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/pagedbyfilter/', { params: params })
            .pipe();
    }

    createGrupo(grupo: GrupoViewModel): Observable<any> {
        return this.http.post<GrupoViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/PostGrupo', grupo).pipe();
    }

    editGrupo(grupo: GrupoViewModel): Observable<any> {
        return this.http.put<GrupoViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/PutGrupo', grupo).pipe();
    }

    deleteGrupo(id: number): Observable<any> {
        return this.http.delete<GrupoViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/DeleteGrupo/' + id).pipe();
    }

    getForma(id: number): Observable<FormaViewModel> {
        return this.http.get<FormaViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/formas/' + id).pipe();
    }

    getFormaByIdGrupo(id: number): Observable<FormaItemResultsViewModel> {
        return this.http.get<FormaItemResultsViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/FormasIdGrupo/' + id).pipe();
    }

    getSubFormaByIdForma(id: number): Observable<SubFormaItemResultsViewModel> {
        return this.http.get<SubFormaItemResultsViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/SubFormasIdForma/' + id).pipe();
    }

    createForma(forma: FormaViewModel): Observable<any> {
        return this.http.post<FormaViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/PostForma', forma).pipe();
    }

    editForma(forma: FormaViewModel): Observable<any> {
        return this.http.put<FormaViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/PutForma', forma).pipe();
    }

    deleteForma(id: number): Observable<any> {
        return this.http.delete<FormaViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/DeleteForma/' + id).pipe();
    }

    getSubForma(id: number): Observable<SubFormaViewModel> {
        return this.http.get<SubFormaViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/subformas/' + id).pipe();
    }

    createSubForma(subforma: SubFormaViewModel): Observable<any> {
        return this.http.post<SubFormaViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/PostSubforma', subforma).pipe();
    }

    editSubForma(subforma: SubFormaViewModel): Observable<any> {
        return this.http.put<SubFormaViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/PutSubforma', subforma).pipe();
    }

    deleteSubForma(id: number): Observable<any> {
        return this.http.delete<SubFormaViewModel>(this.baseUrl + 'api/mantenimiento/grupoforma/DeleteSubForma/' + id).pipe();
    }

    resetFilter() {
        this.currentFilterGrupo = undefined;
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            //this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
